// ** React Imports
import { useState, useEffect } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    Fab,
    FormControlLabel,
    Checkbox,
    FormGroup,
    Tooltip,
    IconButton
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import { useNavigate } from "react-router-dom";

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'

import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../components/icon';
import MsiDatagridDynamic from '../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    // ** State
    const [listData, setListData] = useState<any[]>([])
    const [listJenis, setListJenis] = useState<any[]>([])
    const [listSubAkun, setListSubAkun] = useState<any[]>([])

    const [mode, setMode] = useState<any>(null)
    const [idD, setIdD] = useState<any>(null)
    const [openDialog, setOpenDialog] = useState<boolean>(false)

    const navigate = useNavigate();

    useEffect(() => {
        getData()
        getJenis()
    }, [])


    const getData = () => {
        setListData([])
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/acc/account/list'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getJenis = () => {

        const url = apiUrl.apiUrl + '/acc/account/list-jenis'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    const dataWithId = data.map((item: any, idx: number) => ({ ...item, id: idx + 1 }));
                    setListJenis(dataWithId);
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getDetail = (ids: any) => {
        setIdD(ids)
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/acc/account/detail/' + ids
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    getSubAkun(data.jenis_akun)
                    setValue('accakun_id', data.accakun_id)
                    setValue('jenis_akun', data.jenis_akun)
                    setValue('is_aktif', data.is_aktif)
                    setValue('nama', data.nama)
                    setValue('is_debet', data.is_debet)
                    setValue('is_neraca', data.is_neraca)
                    setValue('syscabang_id', data.syscabang_id)

                    setOpenDialog(true)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getSubAkun = (val: any) => {
        setListSubAkun([])
        if (val == null || val === '') return;

        const url = apiUrl.apiUrl + `/acc/account/list-sub-akun/${val}`
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListSubAkun(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }


    const handleEdit = (row: any) => {
        // navigate('/acc/master-account/detail/' + row.id)

        setMode('edit')
        getDetail(row.id)
    };

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/acc/account/delete/' + row.id
                axios
                    .delete(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };

    interface FormInputs {
        syscabang_id: any,
        accakun_id: any,
        nama: any,
        jenis_akun: any,
        id: any,
        is_debet: any,
        is_aktif: any,
        is_neraca: any,
        is_transaction: any,
    }

    const defaultValues = {
        syscabang_id: cabang,
        is_aktif: 1
    }

    const {
        control,
        handleSubmit,
        setValue,
        resetField,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: any) => {
        setOpenDialog(false);
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                let url = ""
                if (mode === 'Buat') {
                    url = apiUrl.apiUrl + '/acc/account/add'
                } else {
                    url = apiUrl.apiUrl + '/acc/account/edit/' + idD
                }
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    setOpenDialog(false)
                                    getData()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const customRender = [
        {
            key: "is_neraca",
            renderCell: (row: any) => (
                <FormControlLabel
                    label=''
                    control={<Checkbox checked={row.is_neraca} readOnly name='controlled' />}
                />
            ),
        },
        {
            key: "is_debet",
            renderCell: (row: any) => (
                <FormControlLabel
                    label=''
                    control={<Checkbox checked={row.is_debet} readOnly name='controlled' />}
                />
            )
        },
        {
            key: "is_transaction",
            renderCell: (row: any) => (
                <FormControlLabel
                    label=''
                    control={<Checkbox checked={row.is_transaction == 1 ? true : false} readOnly name='controlled' />}
                />
            ),
        },
    ];


    const action = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Tooltip title="Lihat Detail" placement="top">
                        <Box>
                            <IconButton onClick={() => handleEdit(row)}>
                                <Icon icon="mdi:pencil" color="primary" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                    <Tooltip title="Hapus" placement="top">
                        <Box>
                            <IconButton onClick={() => handleDelete(row)}>
                                <Icon icon="mdi:trash" color="primary" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
            ),

        },
    ];

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='MASTER ACCOUNT' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                            <Fab color='primary' size='medium'
                                onClick={() => {
                                    setOpenDialog(true)
                                    setMode('Buat')
                                    resetField('is_debet')
                                    resetField('jenis_akun')
                                    resetField('nama')
                                    resetField('accakun_id')
                                    resetField('id')
                                }}>
                                <Icon icon='mdi:plus' fontSize={35} color='white' />
                            </Fab>
                        </Box>
                    </Box>
                    <Divider />
                    <MsiDatagrid key={1} array={listData} customRender={customRender} hiddenColumns={['id']} actions={action} />
                </div>
            </Grid>

            <Dialog
                maxWidth={'md'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title' sx={{ textAlign: 'center', fontSize: '24px !important', color: '#212121' }}>
                    {mode === 'Buat' ? mode : 'Edit'} Master Account
                </DialogTitle>
                <DialogContent sx={{ color: '#212121' }}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', mt: 1 }} spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                    Jenis Akun
                                </Typography>
                                <FormControl fullWidth>
                                    <InputLabel>Jenis Akun</InputLabel>
                                    <Controller
                                        name='jenis_akun'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Jenis Akun'
                                                value={value || ''}
                                                onChange={(e) => {
                                                    onChange(e)
                                                    getSubAkun(e.target.value)
                                                    setValue('jenis_akun', e.target.value)
                                                    listJenis.forEach(element => {
                                                        if (element.jenis_akun === e.target.value) {
                                                            setValue('is_debet', element.is_debet)
                                                        }
                                                    });
                                                }}
                                                readOnly={mode === 'Buat' ? false : true}
                                                error={Boolean(errors.jenis_akun)}
                                            >
                                                {listJenis.map((item, index) => (
                                                    <MenuItem value={item.jenis_akun} key={index}>
                                                        {item.jenis_akun}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.jenis_akun && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                    Sub Akun
                                </Typography>
                                <FormControl fullWidth>
                                    <InputLabel>Sub Akun</InputLabel>
                                    <Controller
                                        name='accakun_id'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Sub Akun'
                                                value={value || ''}
                                                onChange={(e) => {
                                                    onChange(e)
                                                    setValue('accakun_id', e.target.value)
                                                    setValue('id', e.target.value)
                                                }}
                                                readOnly={mode === 'Buat' ? false : true}
                                                error={Boolean(errors.accakun_id)}
                                            >
                                                <MenuItem value={''} key={9999}>
                                                    - Pilih Sub Akun -
                                                </MenuItem>
                                                {listSubAkun.map((item, index) => (
                                                    <MenuItem value={item.id} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.accakun_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            {/* <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                    Nomor Akun
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                type="number"
                                                label="Nomor Akun"
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                inputProps={{ readOnly: mode === 'Buat' ? false : true }}
                                            />
                                        )}
                                    />
                                    {errors.id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid> */}
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                    Nama Akun
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label="Nama Akun"
                                                value={value}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                    {errors.nama && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='is_aktif'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <FormControlLabel
                                                        sx={{ marginBottom: 0 }}
                                                        control={
                                                            <Checkbox
                                                                checked={Boolean(value)}
                                                                onChange={e => {
                                                                    const isChecked = e.target.checked;
                                                                    onChange(isChecked ? 1 : 0);
                                                                }}
                                                                sx={errors.is_aktif ? { color: 'error.main' } : null}
                                                            />
                                                        }
                                                        label='Aktif ?'
                                                    />
                                                )}
                                            />
                                            {errors.is_aktif && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='is_debet'
                                                control={control}
                                                rules={{ required: false }}
                                                render={({ field: { value, onChange } }) => (
                                                    <FormControlLabel
                                                        sx={{ marginBottom: 0 }}
                                                        control={
                                                            <Checkbox
                                                                checked={Boolean(value)}
                                                                disabled
                                                                onChange={e => {
                                                                    const isChecked = e.target.checked;
                                                                    onChange(isChecked ? 1 : 0);
                                                                }}
                                                                sx={errors.is_debet ? { color: 'error.main' } : null}
                                                            />
                                                        }
                                                        label='Debet ?'
                                                    />
                                                )}
                                            />
                                            {errors.is_debet && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='is_neraca'
                                                control={control}
                                                rules={{ required: false }}
                                                render={({ field: { value, onChange } }) => (
                                                    <FormControlLabel
                                                        sx={{ marginBottom: 0 }}
                                                        control={
                                                            <Checkbox
                                                                checked={Boolean(value)}
                                                                onChange={e => {
                                                                    const isChecked = e.target.checked;
                                                                    onChange(isChecked ? 1 : 0);
                                                                }}
                                                                sx={errors.is_neraca ? { color: 'error.main' } : null}
                                                            />
                                                        }
                                                        label='Neraca ?'
                                                    />
                                                )}
                                            />
                                            {errors.is_neraca && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='is_transaction'
                                                control={control}
                                                rules={{ required: false }}
                                                render={({ field: { value, onChange } }) => (
                                                    <FormControlLabel
                                                        sx={{ marginBottom: 0 }}
                                                        control={
                                                            <Checkbox
                                                                checked={Boolean(value)}
                                                                onChange={e => {
                                                                    const isChecked = e.target.checked;
                                                                    onChange(isChecked ? 1 : 0);
                                                                }}
                                                                sx={errors.is_transaction ? { color: 'error.main' } : null}
                                                            />
                                                        }
                                                        label='Transaction ?'
                                                    />
                                                )}
                                            />
                                            {errors.is_transaction && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Button variant='contained' type='submit' sx={{ mt: 5 }}>
                                SIMPAN
                            </Button>
                        </Box>
                    </form>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
        </Grid >
    )
}
